import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

export async function get() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Settings/PasswordPolicy", { headers })).data;
}

export async function set(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Settings/PasswordPolicy", data, { headers })).data;
}
